module.exports = __webpack_public_path__ + "assets/img/29_302_big.3d791ed4.jpg";